import { Button, Card } from "@breakingthelines/design-system";
import { useNavigate } from "react-router-dom";

export function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <Card style={{ maxWidth: 420, margin: "80px auto", textAlign: "center" }}>
      {/* Explicit type: Tailwind's preflight zeroes heading size, weight and
          margin, and these two pages have no stylesheet of their own. */}
      <h3 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 12px" }}>403 · Restricted</h3>
      <p style={{ margin: "0 0 20px" }}>
        You do not have permission to access this area. Contact a super admin if you need access.
      </p>
      <Button onClick={() => navigate("/")}>Go back</Button>
    </Card>
  );
}
